//
//
//
//
//
//
//
//
//
//
//
//

import modalMixin from '~/mixins/modal'

export default {
  mixins: [modalMixin],

  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
}
